<template>
  <div id="globalBreadcrumbs" v-if="crumbs.length">
    <div class="container">
      <div class="breadcrumb-row">
        <span
          v-for="(crumb, index) in crumbs"
          :key="index"
          class="breadcrumb-item"
        >
          <router-link
            v-if="index !== crumbs.length - 1 && crumb.path"
            :to="crumb.path"
            class="breadcrumb-link"
          >
            {{ crumb.label }}
          </router-link>

          <span v-else class="breadcrumb-current">
            {{ crumb.label }}
          </span>

          <span
            v-if="index !== crumbs.length - 1"
            class="breadcrumb-separator"
          >
            ›
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Breadcrumbs",
  computed: {
    crumbs() {
      const hiddenRouteNames = [
        "Login",
        "Logout",
        "Registration",
        "RegistrationSuccess",
        "ResetPassword",
        "CreateNewPassword",
        "Page Not Found",
      ];

      const routeName = this.$route && this.$route.name ? this.$route.name : "";

      if (hiddenRouteNames.includes(routeName)) {
        return [];
      }

      if (this.$route && this.$route.meta && Array.isArray(this.$route.meta.breadcrumbs)) {
        return this.$route.meta.breadcrumbs;
      }

      if (routeName === "Index" || this.$route.path === "/") {
        return [];
      }

      return [
        { label: "Home", path: "/" },
        {
          label:
            (this.$route &&
              this.$route.meta &&
              this.$route.meta.breadcrumb) ||
            routeName ||
            "Page",
          path: null,
        },
      ];
    },
  },
};
</script>

<style scoped>
#globalBreadcrumbs {
  width: 100%;
}

#globalBreadcrumbs .container {
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.breadcrumb-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
  padding: 10px 0;
  min-height: 38px;
}

.breadcrumb-item {
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  line-height: 1.2;
  color: #333;
}

.breadcrumb-link {
  color: #333;
  text-decoration: none;
}

.breadcrumb-link:hover {
  color: #c0392b;
  text-decoration: underline;
}

.breadcrumb-current {
  color: #333;
  font-weight: 600;
}

.breadcrumb-separator {
  margin: 0 10px;
  color: #666;
}
</style>